/**
 * État du tunnel de connexion téléphone → OTP → PIN.
 *
 * ⚠ L'app native passe `otpToken` dans les paramètres de navigation. Sur le web,
 * ce serait une fuite : le token finirait dans l'historique du navigateur, dans
 * l'en-tête Referer et dans les journaux du service worker. On le garde donc en
 * mémoire seulement — un rechargement de page renvoie à l'étape 1, ce qui est
 * le comportement voulu.
 */

export interface AuthFlow {
  phone: string
  otpToken?: string
  needsPin?: boolean
}

let flow: AuthFlow | null = null

export function setAuthFlow(next: AuthFlow) {
  flow = next
}

export function updateAuthFlow(patch: Partial<AuthFlow>) {
  if (!flow) return
  flow = { ...flow, ...patch }
}

export function getAuthFlow(): AuthFlow | null {
  return flow
}

export function clearAuthFlow() {
  flow = null
}
